import { Injectable, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Invoice } from "../models/invoice.models";
import { InvoiceResendEmailModalComponent } from "../components/invoice-resend-email-modal/invoice-resend-email-modal.component";
import { DialogManagerService } from "@shared/services/dialog-manager.service";

@Injectable({
  providedIn: "root",
})
export class InvoiceResendEmailService {
  private dialogService = inject(DialogManagerService);

  /**
   * Opens a modal to confirm and resend invoice email
   * @param invoice The invoice to resend
   * @returns Dialog reference
   */
  openResendEmailModal(invoice: Invoice) {
    const dialogRef = this.dialogService.openConfirm(
      InvoiceResendEmailModalComponent,
      {
        width: "427px",
        height: "auto",
        panelClass: "horus-confirmation-panel",
        data: {
          invoice,
        },
        restoreFocus: false,
      },
    );

    return dialogRef;
  }
}
